import { Autocomplete, TextField } from "@mui/material";
import { LabelForm } from "components/label";
import { FakeData } from "constants/FakeData";
import React from "react";
import { Controller } from "react-hook-form";

const DropdownMulti = ({
	data,
	label,
	placeholder = "",
	control,
	name,
	...rest
}) => {
	return (
		<div className="form-group pms-select-multi">
			<LabelForm>{label}</LabelForm>
			<Controller control={control} name={name} render={({ field: { onChange, value } }) => {
				return (
					<Autocomplete
						multiple
						limitTags={2}
						onChange={(event, value) => onChange(value)}
						options={FakeData.listLeadType}
						label="limitTags"
						size="small"
						getOptionLabel={option => option.name}
						renderInput={params => (
							<TextField {...params} variant="standard" />
						)}
					/>
				);
			}}></Controller>

		</div>
	);
};

export default DropdownMulti;
